import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
export const Paragraph = JSX(({ children, ...styleProps }) => (_jsx("p", { className: style('font-sans', Object.values(styleProps)), children: children })));
//# sourceMappingURL=Paragraph.js.map